import { CircularProgress } from "@mui/material";
import React from "react";

const LoadingForm: React.FC = () => <CircularProgress />;

export default LoadingForm;
